import { ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';

import { Icon } from 'common/components/Icon';
import { TColorKeys } from 'theme/palette';

export interface IToggleButton<Key extends string> {
    key: Key;
    icon: string;
    color?: TColorKeys;
}

export interface IProps<Key extends string> {
    noDefault?: boolean;
    value?: Key;
    buttons: IToggleButton<Key>[];
    onClickButton: (viewKey: Key) => void;
}

export const ButtonToggle = <Key extends string>({
    noDefault,
    value,
    buttons = [],
    onClickButton,
}: IProps<Key>) => {
    const theme = useTheme();
    const initView = value || (noDefault ? undefined : buttons[0].key);

    return (
        <ToggleButtonGroup exclusive fullWidth value={initView}>
            {buttons.map((view) => {
                const { key, icon, color } = view;

                const isActive = key === value;

                const sx = !!color
                    ? {
                          '&.Mui-selected': {
                              backgroundColor: `${color}.main`,
                          },

                          '&:hover': {
                              backgroundColor: `${color}.main`,

                              'svg path': {
                                  fill: theme.vars.palette[color].contrastText,
                              },
                          },

                          // When color is passed we set the fill color through sx props
                          // as the icon component does not work well with dynamic changing colors
                          'svg path': {
                              fill:
                                  !!color && isActive
                                      ? theme.vars.palette[color].contrastText
                                      : 'body.main',
                          },
                      }
                    : undefined;

                return (
                    <ToggleButton
                        key={key}
                        sx={sx}
                        value={key}
                        onClick={() => onClickButton(key)}
                    >
                        <Icon color="body" path={icon} size="2.4rem" />
                    </ToggleButton>
                );
            })}
        </ToggleButtonGroup>
    );
};
